/* mh-pdp-recos.js — product-details recommendation rows.
 *
 * Rows (each hidden if it returns nothing), rendered as WRAPPING GRIDS (no
 * horizontal scroller) using the shared product-card-new card so they match the
 * vendor/related rows and inherit the delivery + PayLater badge hydrators:
 *   • Shoppers also viewed            → /api/also_viewed.php
 *   • Brands in {category}            → /api/category_brands.php   (brand tiles)
 *   • Top sellers in {category}       → /api/category_bestsellers.php
 *   • Inspired by your browsing       → /api/reco_from_history.php
 *   • Recently viewed                 → /api/cards_by_handles.php
 *
 * Product cards are fetched via /products/<handle>?view=mhcard (like the
 * homepage personalize rows) and lazy-loaded per row (IntersectionObserver).
 * After injection each grid fires mh:product-cards-injected so the fulfilment
 * (delivery) + PayLater + quick-buy hydrators badge the cards consistently.
 * Browsing history lives in localStorage (mh_bh), newest-first.
 */
(function () {
  var mount = document.getElementById('mh-pdp-recos');
  if (!mount) return;
  var handle = mount.getAttribute('data-handle');
  if (!handle) return;

  var API = 'https://admin.menahub.com/api';
  var IS_AR = location.pathname.indexOf('/ar') === 0;
  var pre = IS_AR ? '/ar' : '';
  var T = IS_AR ? {
    viewAll: 'عرض الكل', clear: 'مسح',
    alsoViewed: 'تصفّح المتسوقون أيضًا', brandsIn: 'ماركات في ',
    topIn: 'الأكثر مبيعًا في ', inspired: 'مستوحى من تصفّحك', recent: 'شوهدت مؤخرًا'
  } : {
    viewAll: 'View all', clear: 'Clear',
    alsoViewed: 'Shoppers also viewed', brandsIn: 'Brands in ',
    topIn: 'Top sellers in ', inspired: 'Inspired by your browsing', recent: 'Recently viewed'
  };

  /* ---- localStorage browsing history ---- */
  var HKEY = 'mh_bh';
  function readHistory() { try { return JSON.parse(localStorage.getItem(HKEY) || '[]'); } catch (e) { return []; } }
  function writeHistory(list) { try { localStorage.setItem(HKEY, JSON.stringify(list)); } catch (e) {} }
  function pushHistory(h) {
    var list = readHistory().filter(function (x) { return x !== h; });
    list.unshift(h); list = list.slice(0, 30); writeHistory(list); return list;
  }
  var history = pushHistory(handle);

  /* ---- DOM helpers ---- */
  function el(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }
  function clear(n) { while (n.firstChild) n.removeChild(n.firstChild); }
  function getJSON(url) { return fetch(url, { credentials: 'omit' }).then(function (r) { return r.json(); }).catch(function () { return null; }); }

  /* ---- product-card-new fetch (same template + cache as homepage rows) ---- */
  function extractCard(html) {
    try { return new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cards-only] .cards-only-cell'); }
    catch (e) { return null; }
  }
  function cardKey(h) { return 'mh:reco:' + (IS_AR ? 'ar' : 'en') + ':' + h; }
  function fetchCard(h) {
    try {
      var raw = sessionStorage.getItem(cardKey(h));
      if (raw) { var o = JSON.parse(raw); if (o && o.h && (Date.now() - o.t) < 1800000) { var hit = extractCard(o.h); if (hit) return Promise.resolve(hit); } }
    } catch (e) {}
    var url = pre + '/products/' + encodeURIComponent(h) + '?view=mhcard';
    return fetch(url, { credentials: IS_AR ? 'include' : 'omit' })
      .then(function (r) { if (!r.ok) throw 0; return r.text(); })
      .then(function (html) {
        var node = extractCard(html); if (!node) throw 0;
        try { sessionStorage.setItem(cardKey(h), JSON.stringify({ t: Date.now(), h: html })); } catch (e) {}
        return node;
      });
  }

  /* ---- lazy: fetch a row's cards only when it nears the viewport ---- */
  function lazy(node, cb) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); cb(); } });
    }, { rootMargin: '700px 0px' });
    io.observe(node);
  }

  /* ---- ordered slot placement (rows resolve out of order) ---- */
  var ORDER = ['also', 'brands', 'top', 'inspired', 'recent'];
  var slots = {};
  function placeSlot(key) {
    if (slots[key]) return slots[key];
    var sec = el('section', 'mh-pdp-section mh-reco-sec');
    sec.setAttribute('data-reco', key);
    var before = null;
    for (var i = ORDER.indexOf(key) + 1; i < ORDER.length; i++) { if (slots[ORDER[i]]) { before = slots[ORDER[i]]; break; } }
    mount.insertBefore(sec, before);
    slots[key] = sec;
    return sec;
  }
  function header(title, viewAllUrl, clearFn) {
    var head = el('div', 'mh-reco-head');
    var h = el('h2', 'mh-section-heading'); h.textContent = title; head.appendChild(h);
    if (clearFn) { var cb = el('button', 'mh-reco-clear'); cb.type = 'button'; cb.textContent = T.clear; cb.addEventListener('click', clearFn); head.appendChild(cb); }
    else if (viewAllUrl) { var va = el('a', 'mh-reco-va'); va.href = pre + viewAllUrl; va.textContent = T.viewAll; head.appendChild(va); }
    return head;
  }

  /* ---- product row: product-card-new grid + badge hydration ---- */
  function productRow(key, title, viewAllUrl, products, clearFn) {
    if (!products || !products.length) return;
    var sec = placeSlot(key); clear(sec);
    sec.appendChild(header(title, viewAllUrl, clearFn));
    var grid = el('div', 'mh-recommended-grid'); sec.appendChild(grid);
    lazy(grid, function () {
      Promise.all(products.map(function (p) { return fetchCard(p.handle).catch(function () { return null; }); }))
        .then(function (nodes) {
          // Skip empty cards (unpublished / OOS / hidden) so no blank cells appear.
          nodes.forEach(function (n) { if (n && n.querySelector && n.querySelector('.mh-card')) grid.appendChild(n); });
          try { window.dispatchEvent(new CustomEvent('mh:product-cards-injected', { detail: { container: grid } })); } catch (e) {}
        });
    });
  }

  /* ---- brand row: simple tiles in a wrapping grid ---- */
  function brandRow(key, title, viewAllUrl, brands) {
    if (!brands || !brands.length) return;
    var sec = placeSlot(key); clear(sec);
    sec.appendChild(header(title, viewAllUrl, null));
    var grid = el('div', 'mh-reco-brandgrid'); sec.appendChild(grid);
    brands.forEach(function (b) {
      var a = el('a', 'mh-reco-brandcard'); a.href = pre + b.url;
      var w = el('div', 'mh-reco-brandlogo');
      if (b.logo) { var im = el('img'); im.src = b.logo; im.loading = 'lazy'; im.alt = b.name; w.appendChild(im); }
      else { var sp = el('span'); sp.textContent = b.name; w.appendChild(sp); }
      a.appendChild(w);
      var n = el('div', 'mh-reco-brandname'); n.textContent = b.name; a.appendChild(n);
      grid.appendChild(a);
    });
  }

  /* ---- build rows ---- */
  getJSON(API + '/reco_meta.php?handle=' + encodeURIComponent(handle)).then(function (meta) {
    var cat = meta && meta.category, catName = cat ? cat.name : '';
    getJSON(API + '/also_viewed.php?handle=' + encodeURIComponent(handle) + '&limit=12').then(function (d) {
      if (d && d.products) productRow('also', T.alsoViewed, cat ? cat.url : '', d.products);
    });
    if (cat) {
      getJSON(API + '/category_brands.php?category_id=' + cat.id + '&limit=18').then(function (d) {
        if (d && d.brands) brandRow('brands', T.brandsIn + catName, cat.url, d.brands);
      });
      getJSON(API + '/category_bestsellers.php?category_id=' + cat.id + '&handle=' + encodeURIComponent(handle) + '&limit=12').then(function (d) {
        if (d && d.products) productRow('top', T.topIn + catName, cat.url, d.products);
      });
    }
  });

  var others = history.filter(function (h) { return h !== handle; });
  if (others.length) {
    getJSON(API + '/reco_from_history.php?handles=' + encodeURIComponent(others.slice(0, 15).join(',')) + '&exclude=' + encodeURIComponent(handle) + '&limit=12').then(function (d) {
      if (d && d.products) productRow('inspired', T.inspired, '', d.products);
    });
    getJSON(API + '/cards_by_handles.php?handles=' + encodeURIComponent(others.slice(0, 20).join(',')) + '&exclude=' + encodeURIComponent(handle) + '&limit=12').then(function (d) {
      if (d && d.products) productRow('recent', T.recent, '', d.products, function () {
        writeHistory([handle]);
        ['recent', 'inspired'].forEach(function (k) { var s = slots[k]; if (s && s.parentNode) s.parentNode.removeChild(s); });
      });
    });
  }
})();
